import { Box } from '@primer/react';
import { CSSProperties } from 'react';
import { ValueChain } from '../../../../../../../../common/model/types';
import { friendlyValueChainExternal } from '../../../../../../../untidy/texts';
import { ImpactLensLegendItem } from '../../../../../core/impact-lenses/shared/impact-lens-legend-item';
import { useImpactChartFontSizes } from '../context';
import { getValueChainFill } from '../value-chain-fill';

interface Props {
  valueChains?: ValueChain[];
  style?: CSSProperties;
}

export function ValueChainsLegend(props: Props) {
  const { legendText: fontSize } = useImpactChartFontSizes();
  const valueChains = props.valueChains ?? allValueChains;
  return (
    <Box style={{ fontSize, ...props.style }} sx={{ display: ['none', 'flex'], alignItems: 'center', gap: 2 }}>
      {valueChains.map(valueChain => {
        return (
          <ImpactLensLegendItem
            key={valueChain}
            text={friendlyValueChainExternal(valueChain)}
            color={getValueChainFill(valueChain)}
          />
        );
      })}
    </Box>
  );
}

const allValueChains = [ValueChain.UPSTREAM, ValueChain.INTERNAL, ValueChain.DOWNSTREAM, ValueChain.ANY];
